export function isEllipsisActive(element: HTMLElement) {
  if (element.clientWidth < element.scrollWidth) {
    const style = window.getComputedStyle(element) || element.style;
    return style.textOverflow === 'ellipsis';
  }
  return false;
}
